import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import { FC } from 'react';
import { CloseIcon } from '../../../../icons';
import { InformationDialogTitle } from '../informationDialog/title';

type Props = {
  title?: string;
  content: string | JSX.Element;
  onClose?: () => void;
} & Pick<DialogProps, 'open'>;

export const ContractViewDialog: FC<Props> = ({ open, onClose, title, content }) => {
  return (
    <Dialog
      PaperProps={{
        className: 'flex flex-col p-0 h-[640px] max-w-[950px] overflow-hidden shadow-900'
      }}
      open={open}
      onClose={onClose}
    >
      {title && <InformationDialogTitle title={title} onClose={onClose} />}
      <DialogTitle className="flex flex-col items-center gap-4 pt-0 pb-0 text-4xl">
        {onClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              padding: 0,
              right: 24,
              top: 24,
              color: (theme) => theme.palette.primary.dark
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent className="flex flex-col p-0 pb-0 flex-1 overflow-y-auto overflow-x-hidden">
        {typeof content === 'string' ? (
          <Typography paragraph className="mb-0">
            {content}
          </Typography>
        ) : (
          content
        )}
      </DialogContent>
    </Dialog>
  );
};
